import React from "react";

// @see https://medium.com/trabe/catching-asynchronous-errors-in-react-using-error-boundaries-5e8a5fd7b971
// it allows to manage error in async code so that ErrorBoundary will catch it
export const useAsyncError = () => {
    const [_, setError] = React.useState();
    return React.useCallback(
        (e: Error) => {
            setError(() => {
                throw e;
            });
        },
        [setError],
    );
};
